import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Link, Typography } from 'wtb-components';
import { ReactComponent as WTBLogo } from 'assets/images/wtb-logo.svg';
import { useDialogNavigationContext, useLocaleContext, useTransactionContext } from 'context';
import { Divider } from 'components';
import { TRANSACTION_STATES } from 'constants.js';
import styles from './Footer.module.css';

const FeedBack = () => {
  const { t: translate } = useTranslation();

  return (
    <div className={styles.feedback}>
      <Typography
        variant="caption"
        align="center"
        id="feedback-title"
        color="textSecondary"
      >
        {translate('feedback.howDidPaymentGo')}
      </Typography>

      <Link
        className={styles.link}
        variant="caption"
        align="center"
        color="tertiary"
        id="feedback-link"
        href="https://forms.gle/YZVR1KeydRtukRyLA"
        underline="always"
        target="_blank"
      >
        {translate('feedback.leaveFeedback')}
      </Link>

    </div>
  );
};

const Footer = () => {
  const { hasFooter } = useDialogNavigationContext();
  const location = useLocation();
  const { translate } = useLocaleContext();
  const { transaction: { state } } = useTransactionContext();

  const showFeedBack = state === TRANSACTION_STATES.FINISHED && location.pathname.includes('/success');

  if (!hasFooter) {
    return null;
  }

  return (
    <>
      <Divider size="mid" />

      <div className={styles.footer}>
        <Typography variant="caption" color="textSecondary">
          {translate('footer.paymentProvider')}
        </Typography>

        <WTBLogo />
      </div>
      {showFeedBack && <FeedBack />}
    </>
  );
};

export default Footer;
